import React, { useState } from "react";

const SendPushNotificationPopup = ({ onClose, dropdownOptions, onSubmit }) => {
  const decodeHTMLEntities = (text) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  const [sendPushData, setSendPushData] = useState({
    title: "",
    pushTemplate: "",
    message: "",
  });

  const handleSendPushInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "pushTemplate") {
      const selectedTemplate =
        dropdownOptions.templatePushNotificationList.find(
          (template) => template.id === parseInt(value)
        );

      setSendPushData((prevData) => ({
        ...prevData,
        pushTemplate: value,
        message: selectedTemplate
          ? decodeHTMLEntities(selectedTemplate.message)
          : "",
      }));
    } else {
      setSendPushData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(sendPushData);
    onClose();
    setSendPushData({
      title: "",
      pushTemplate: "",
      message: "",
    });
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-6">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Send Push Notification
              </h5>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-default float-end"
                onClick={onClose}
              >
                &times;
              </button>
            </div>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">Title</label>
                    <input
                      type="text"
                      name="title"
                      placeholder="Enter Title"
                      className="form-control"
                      value={sendPushData.title}
                      onChange={handleSendPushInputChange}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">
                      Select Push Notification Template
                    </label>
                    <select
                      name="pushTemplate"
                      className="form-control"
                      onChange={handleSendPushInputChange}
                      value={sendPushData.pushTemplate}
                    >
                      <option value="">- Select -</option>
                      {dropdownOptions.templatePushNotificationList.map(
                        (option, index) => (
                          <option key={index} value={option.id}>
                            {option.template_name}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>

                <div className="col-md-12">
                  <fieldset className="form-group">
                    <label className="form-label semibold">Message</label>
                    <textarea
                      name="message"
                      placeholder="Enter Message"
                      className="form-control"
                      value={sendPushData.message}
                      onChange={handleSendPushInputChange}
                    />
                  </fieldset>
                </div>

                <div className="col-md-3">
                  <div style={{ float: "left", marginTop: "20px" }}>
                    <button
                      type="submit"
                      name="submit"
                      className="btn btn-primary mx-2"
                    >
                      Submit
                    </button>
                  </div>
                  <div
                    style={{
                      float: "left",
                      marginTop: "20px",
                      marginLeft: "10px",
                    }}
                  >
                    <button
                      type="button"
                      name="cancel"
                      className="btn btn-default"
                      onClick={onClose} // Close the modal on cancel
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendPushNotificationPopup;
